import { configureStore } from '@reduxjs/toolkit';
import vehiclesReducer from './slice/vehicles';
import vehicleReducer from './slice/vehicle';
import modelReducer from './slice/model.response';
import timelinesReducer from './slice/timelines.response';
import timelineReducer from './slice/timeline';
export const store = configureStore({
  reducer: {
    vehicles: vehiclesReducer,
    vehicle: vehicleReducer,
    model: modelReducer,
    timelines: timelinesReducer,
    timeline: timelineReducer
  },
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;